import React, { memo } from 'react'

import * as styles from './fieldError.module.scss'

const FieldError = ({ text }: FieldErrorProps) => (
   <div className={styles.wrapper}>{text}</div>
)

export default memo(FieldError)
